<script setup lang="ts">
import { StatusVariant } from '@/munio/definitions'
import Icon from '@component/Icon.vue'
import MdlLabel from '@component/mdl/Label.vue'

withDefaults(
  defineProps<{
    type?: StatusVariant
    label: string | number
    icon?: string
    identifier?: string | number
    outlined?: boolean
  }>(),
  {
    outlined: false,
  },
)
</script>

<template>
  <MdlLabel :type="type" :outlined="outlined">
    <span>{{ label }}</span>
    <Icon v-if="icon" :name="icon" small />
    <span v-if="identifier">
      <span v-if="!icon">#</span>
      {{ identifier }}
    </span>
  </MdlLabel>
</template>
